/* store/modules/blockUI */
const defaultMessage = 'Loading, please wait...'

const state = {
    show: false,
    message: null
}

const mutations = {
    SET_BLOCKUI_HIDE(state) {
        state.show = false
    },

    SET_BLOCKUI_MESSAGE(state, data) {
        state.message = data
        state.show = true
    },

    SET_BLOCKUI_SHOW(state) {
        state.message = defaultMessage
        state.show = true
    }
}

const actions = {
    setBlockUIHide: ({ commit }) => {
        commit('SET_BLOCKUI_HIDE')
    },

    setBlockUIMessage: ({ commit }, value) => {
        commit('SET_BLOCKUI_MESSAGE', value)
    },

    setBlockUIShow: ({ commit }) => {
        commit('SET_BLOCKUI_SHOW')
    }
}

const getters = {
    getBlockUIShow: state => {
        return state.show
    },

    getBlockUIMessage: state => {
        return state.message
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}